import { z } from 'zod';
import { fallback } from '@/lib/utils/zodFallback';

export const filesListSearch = z.object({
  page: fallback(z.number().int().min(0), 0),
  count: fallback(z.number().int().min(10).max(500), 20),
  sort: z.string().optional(),
  filters: z.record(z.string(), z.array(z.string())).optional(),
  quickFilter: fallback(z.string(), ''),
});

export type FilesListSearch = z.infer<typeof filesListSearch>;

export interface FileListParams {
  page?: number;
  count?: number;
  sort?: string;
  filter?: string;
  isArchived?: boolean;
}
